/* eslint-disable max-len */
import {
  GET_TYPES,
  GET_TYPES_SUCCESS,
  GET_TYPES_FAILED,
  GET_SUBTYPES,
  GET_SUBTYPES_SUCCESS,
  GET_SUBTYPES_FAILED,
  GET_ALL_CASE,
  GET_ALL_CASE_SUCCESS,
  GET_ALL_CASE_FAILED,
  GET_ALL_CASE_DASHBOARD,
  GET_ALL_CASE_DASHBOARD_SUCCESS,
  GET_ALL_CASE_DASHBOARD_FAILED,
  CREATE_CASE,
  CREATE_CASE_SUCCESS,
  CREATE_CASE_FAILED,
  DELETE_CASE,
  DELETE_CASE_SUCCESS,
  DELETE_CASE_FAILED,
  GET_CASE_ID,
  GET_CASE_ID_SUCCESS,
  GET_CASE_ID_FAILED,
  UPDATE_CASE,
  UPDATE_CASE_SUCCESS,
  UPDATE_CASE_FAILED,
  UPDATE_CASE_MANY,
  UPDATE_CASE_MANY_SUCCESS,
  UPDATE_CASE_MANY_FAILED,
  CREATE_SUBCASE,
  CREATE_SUBCASE_SUCCESS,
  CREATE_SUBCASE_FAILED,
  UPDATE_SUBCASE,
  UPDATE_SUBCASE_SUCCESS,
  UPDATE_SUBCASE_FAILED,
  DELETE_SUBCASE,
  DELETE_SUBCASE_SUCCESS,
  DELETE_SUBCASE_FAILED,
  GET_SUMMARY_CASES,
  GET_SUMMARY_CASES_SUCCESS,
  GET_SUMMARY_CASES_FAILED,
  GET_DOCUMENT_REQUEST,
  GET_DOCUMENT_SUCCESS,
  GET_DOCUMENT_FAILURE,
  GET_EXCEL_CASES,
  GET_EXCEL_CASES_SUCCESS,
  GET_EXCEL_CASES_FAILED
} from '../../api/Types';
import { caseTypes } from '../types/cases.types';

const initState = {
  collection: [],
  count: 0,
  limit: 10,
  doc: '',
  docS3: {
    data: null,
    loading: false
  },
  allS3Docs: {
    data: [],
    loading: false
  },
  docStatus: '',
  loading: false,
  allCases: [],
  loadingReasing: false,
  disableCreate: false,
  dataDashboard: {},
  gettingDataDashboard: false,
  summary: {
    withinTerm: 0,
    OutTerm: 0,
    open: 0,
    close: 0,
    total: 0,
  },
  exportedData: {
    data: null,
    loading: false
  },
  manyCases: {
    response: null,
    loading: false
  },
  requestGrounds: {
    data: [],
    loading: false,
  },
  requestClassifications: {
    data: [],
    loading: false,
  },
  caseInfo: {
    status: '',
    _id: '',
    type: {
      _id: '',
      name: '',
    },
    subtype: {
      _id: '',
      name: '',
    },
    origin: '',
    client: {
      emails: [
        '',
      ],
      _id: '',
      names: '',
      paternalSurname: '',
      maternalSurname: '',
      rent: 0,
      birthdate: '',
      rut: '',
      phones: [
        {
          code: '',
          number: '',
        },
      ],
      addresses: [],
      profile: null,
      nationality: {
        value: '',
        label: '',
      },
      sex: {
        value: '',
        label: '',
      },
      civilStatus: {
        value: '',
        label: '',
      },
      createdAt: '',
      updatedAt: '',
      casesExcel: ''
    },
    isRedec: false,
    requestGrounds: null,
    requestClassification: null,
  },
};

const caseReducer = (state = initState, action) => {
  switch (action.type) {
    case caseTypes.GET_EXPORT_DATA_REQUEST:
      return { ...state, exportedData: { ...state.exportedData, loading: true } };
    case caseTypes.GET_EXPORT_DATA_SUCCESS:
      return {
        ...state,
        exportedData: {
          ...state.exportedData,
          loading: false,
          data: action.payload.body
        }
      };
    case caseTypes.GET_EXPORT_DATA_FAILED:
      return {
        ...state,
        exportedData: {
          ...state.exportedData,
          loading: false,
          error: action.payload.error
        }
      };
    case caseTypes.POST_MANY_CASES_REQUEST:
      return { ...state, manyCases: { ...state.manyCases, loading: true } };
    case caseTypes.POST_MANY_CASES_SUCCESS:
      return {
        ...state,
        manyCases: {
          ...state.manyCases,
          loading: false,
          response: action.payload.body
        }
      };
    case caseTypes.POST_MANY_CASES_FAILED:
      return {
        ...state,
        manyCases: {
          ...state.manyCases,
          loading: false,
          error: action.payload.error
        }
      };
    case GET_SUMMARY_CASES:
      return { ...state, disable: true };
    case GET_SUMMARY_CASES_SUCCESS:
      return {
        ...state,
        disable: false,
        summary: action.payload.summary,
      };
    case GET_SUMMARY_CASES_FAILED:
      return { ...state, cargando: false, error: action.payload.error };
    case GET_TYPES:
      return { ...state, disable: true };
    case GET_TYPES_SUCCESS:
      return {
        ...state,
        disable: false,
        types: action.payload.typesCases,
      };
    case GET_TYPES_FAILED:
      return { ...state, cargando: false, error: action.payload.error };
    case GET_ALL_CASE:
      return { ...state, loadingCases: true };
    case GET_ALL_CASE_SUCCESS:
      return {
        ...state,
        loadingCases: false,
        allCases: action.payload.allCases,
        countCases: action.payload.countCases,
        limitCases: action.payload.limitCases,
      };
    case GET_ALL_CASE_FAILED:
      return { ...state, loadingCases: false, error: action.payload.error };
    case GET_ALL_CASE_DASHBOARD:
      return { ...state, gettingDataDashboard: true };
    case GET_ALL_CASE_DASHBOARD_SUCCESS:
      return { ...state, gettingDataDashboard: false, dataDashboard: action.payload };
    case GET_ALL_CASE_DASHBOARD_FAILED:
      return { ...state, gettingDataDashboard: false, error: action.payload.error };
    case GET_CASE_ID:
      return { ...state, loadingInfoCase: true };
    case GET_CASE_ID_SUCCESS:
      return {
        ...state,
        loadingInfoCase: false,
        caseInfo: action.payload.caseInfo,
      };
    case GET_CASE_ID_FAILED:
      return { ...state, loadingInfoCase: false, error: action.payload.error };
    case DELETE_CASE:
      return { ...state };
    case DELETE_CASE_SUCCESS:
      return { ...state };
    case DELETE_CASE_FAILED:
      return { ...state };
    case CREATE_CASE:
      return { ...state, disableCreate: true };
    case CREATE_CASE_SUCCESS:
      return {
        ...state,
        disableCreate: false,
        caso: action.payload.caso,
      };
    case CREATE_CASE_FAILED:
      return { ...state, disableCreate: false, error: action.error };
    case UPDATE_CASE:
      return { ...state, disableCloseCase: true };
    case UPDATE_CASE_SUCCESS:
      return {
        ...state,
        disableCloseCase: false,
      };
    case UPDATE_CASE_FAILED:
      return { ...state, disableCloseCase: false, error: action.error };
    case UPDATE_CASE_MANY:
      return { ...state, loadingReasing: true };
    case UPDATE_CASE_MANY_SUCCESS:
      return {
        ...state,
        loadingReasing: false,
      };
    case UPDATE_CASE_MANY_FAILED:
      return { ...state, loadingReasing: false, error: action.error };
    //descargar excel
    case GET_EXCEL_CASES:
      return { ...state, gettingExcel: true };
    case GET_EXCEL_CASES_SUCCESS:
      return { ...state, gettingExcel: false, casesExcel: action.payload.body };
    case GET_EXCEL_CASES_FAILED:
      return { ...state, casesExcel: '', gettingExcel: false, error: action.payload.error };
    //fin descargar excel
    case CREATE_SUBCASE:
      return { ...state, disableCreateSub: true };
    case CREATE_SUBCASE_SUCCESS:
      return {
        ...state,
        disableCreateSub: false,
        subTypeCreated: action.payload.subType,
      };
    case CREATE_SUBCASE_FAILED:
      return { ...state, disableCreateSub: false, error: action.error };
    case UPDATE_SUBCASE:
      return { ...state, updating: true };
    case UPDATE_SUBCASE_SUCCESS:
      return {
        ...state,
        updating: false,
      };
    case UPDATE_SUBCASE_FAILED:
      return { ...state, updating: false, error: action.error };
    case DELETE_SUBCASE:
      return { ...state };
    case DELETE_SUBCASE_SUCCESS:
      return { ...state };
    case DELETE_SUBCASE_FAILED:
      return { ...state };
    case GET_SUBTYPES:
      return { ...state, loadingSubTypes: true };
    case GET_SUBTYPES_SUCCESS:
      return {
        ...state,
        loadingSubTypes: false,
        subtypes: action.payload.subtypesCases,
        countSubTypes: action.payload.countSubTypes,
        limitSubTypes: action.payload.limitSubTypes,
      };
    case GET_SUBTYPES_FAILED:
      return {
        ...state, loadingSubTypes: false, cargando: false, error: action.payload.error,
      };
    case GET_DOCUMENT_REQUEST:
      return { ...state, loading: true };
    case GET_DOCUMENT_SUCCESS:
      return {
        ...state,
        loading: false,
        doc: action.payload.doc,
      };
    case GET_DOCUMENT_FAILURE:
      return {
        ...state, loading: false, error: action.payload.error,
      };
    case caseTypes.GET_DOCS3_REQUEST:
      return {
        ...state,
        docS3: {
          ...state.docS3,
          loading: true
        }
      };
    case caseTypes.GET_DOCS3_SUCCESS:
      return {
        ...state,
        docS3: {
          data: action.payload.doc,
          loading: false
        }
      };
    case caseTypes.GET_DOCS3_FAILED:
      return {
        ...state,
        docS3: {
          data: null,
          loading: false,
          error: action.error
        }
      };
    case caseTypes.GET_ALLDOCS3_REQUEST:
      return {
        ...state,
        allS3Docs: {
          ...state.allS3Docs,
          loading: true
        }
      };
    case caseTypes.GET_ALLDOCS3_SUCCESS:
      return {
        ...state,
        allS3Docs: {
          data: action.payload.docs,
          loading: false
        }
      };
    case caseTypes.GET_ALLDOCS3_FAILED:
      return {
        ...state,
        allS3Docs: {
          data: [],
          loading: false,
          error: action.error
        }
      };
    case caseTypes.GET_REQUEST_GROUNDS_REQUEST:
      return {
        ...state,
        requestGrounds: {
          ...state.requestGrounds,
          loading: true,
        }
      };
    case caseTypes.GET_REQUEST_GROUNDS_SUCCESS:
      return {
        ...state,
        requestGrounds: {
          data: action.payload.requestGrounds,
          loading: false,
        }
      };
    case caseTypes.GET_REQUEST_GROUNDS_FAILED:
      return {
        ...state,
        requestGrounds: {
          data: [],
          loading: false,
          error: action.payload.error,
        }
      };
    case caseTypes.GET_REQUEST_CLASSIFICATIONS_REQUEST:
      return {
        ...state,
        requestClassifications: {
          ...state.requestClassifications,
          loading: true,
        }
      };
    case caseTypes.GET_REQUEST_CLASSIFICATIONS_SUCCESS:
      return {
        ...state,
        requestClassifications: {
          data: action.payload.requestClassifications,
          loading: false,
        }
      };
    case caseTypes.GET_REQUEST_CLASSIFICATIONS_FAILED:
      return {
        ...state,
        requestClassifications: {
          data: [],
          loading: false,
          error: action.payload.error,
        }
      };
    case caseTypes.RESET_ALLDOCS3:
      return {
        ...state,
        allS3Docs: {
          data: [],
          loading: false,
        }
      };
    case caseTypes.POST_DOCS3_REQUEST:
      return { ...state, disableCreate: true };
    case caseTypes.POST_DOCS3_SUCCESS:
      return {
        ...state,
        docStatus: action.payload.docStatus,
      };
    case caseTypes.POST_DOCS3_FAILED:
      return { ...state, error: action.error };
    case caseTypes.RESET_REFINANCING_CASES:
      return {
        ...state,
        manyCases: {
          response: null,
          loading: false
        }
      };
    default:
      return state;
  }
};

export default caseReducer;
